import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';

const iconeCarro = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/3097/3097180.png',
  iconSize: [40, 40],
  iconAnchor: [20, 20],
});

function CompartilharPublico() {
  const { token } = useParams();
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState(null);
  const [carregando, setCarregando] = useState(true);

  const buscarLocalizacao = async () => {
    try {
      const resposta = await fetch(`${process.env.REACT_APP_API_URL}/compartilhamento/publico/${token}`);
      const json = await resposta.json();

      if (!resposta.ok) {
        setErro(json.erro || 'Não foi possível carregar a localização');
        setDados(null);
      } else {
        setDados(json);
        setErro(null);
      }
    } catch (e) {
      setErro('Erro ao conectar com o servidor');
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    buscarLocalizacao();
    const intervalo = setInterval(buscarLocalizacao, 10000); // atualiza a cada 10 segundos
    return () => clearInterval(intervalo);
  }, [token]);

  if (carregando) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
        <p>Carregando localização...</p>
      </div>
    );
  }

  if (erro) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif', padding: '24px', textAlign: 'center' }}>
        <h2 style={{ color: '#185FA5' }}>Link indisponível</h2>
        <p style={{ color: '#666' }}>{erro}</p>
      </div>
    );
  }

  const expiraEm = new Date(dados.expira_em);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ background: '#185FA5', color: '#fff', padding: '12px 16px', fontFamily: 'sans-serif' }}>
        <strong>{dados.nome}</strong>
        <div style={{ fontSize: '13px', opacity: 0.9 }}>
          Localização compartilhada — expira em {expiraEm.toLocaleString('pt-BR')}
        </div>
      </div>

      <div style={{ flex: 1 }}>
        <MapContainer
          center={[dados.ultima_lat, dados.ultima_lng]}
          zoom={15}
          style={{ height: '100%', width: '100%' }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={[dados.ultima_lat, dados.ultima_lng]} icon={iconeCarro}>
            <Popup>
              {dados.nome}<br />
              Velocidade: {dados.ultima_velocidade} km/h<br />
              Atualizado: {new Date(dados.ultima_atualizacao).toLocaleString('pt-BR')}
            </Popup>
          </Marker>
        </MapContainer>
      </div>

      <p style={{ textAlign: 'center', margin: '8px 0', color: '#999', fontFamily: 'sans-serif', fontSize: '12px' }}>
        Desenvolvido por <a href="https://digitalmaisbr.com.br" style={{ color: '#185FA5' }}>Digital Mais BR</a>
      </p>
    </div>
  );
}

export default CompartilharPublico;